import { fetchWrapper } from "./fetchWrapper";
import { GingerMediaBaseUrl } from "./baseUrls";

export async function getMediaDataById(service: string, gmgAssetCode: string) {
    return fetchWrapper(`${GingerMediaBaseUrl}/getMediaDataById?service=${service}&gmgAssetCode=${gmgAssetCode}`, {
        method: 'GET',
    });
}